
export enum JobViewType {
    Job = 'Job',
    WorkOrder = 'WorkOrder'
}
